/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(3);
var vcardContactForm = __webpack_require__(1213);
$(function () {
    vcardContactForm.init();
});


/***/ },

/***/ 3:
/***/ function(module, exports) {

module.exports = jQuery;

/***/ },

/***/ 1213:
/***/ function(module, exports, __webpack_require__) {

var $ = __webpack_require__(3);
var SendButtonState;
(function (SendButtonState) {
    SendButtonState[SendButtonState["Send"] = 0] = "Send";
    SendButtonState[SendButtonState["Sending"] = 1] = "Sending";
    SendButtonState[SendButtonState["Sent"] = 2] = "Sent";
})(SendButtonState || (SendButtonState = {}));
var FORM_SELECTOR = "form.vcard-contact-form";
var CAPTCHA_FIELD_NAME = "captcha";
var CAPTCHA_SELECTOR = ".captcha";
var CAPTCHA_REFRESH_SELECTOR = "a.refresh";
var BUTTON_SENT_CLASS = "sent";
var FIELD_ERROR_CLASS = "field-error";
var FIELD_ERROR_MESSAGE_CLASS = "field-error-message";
var SUBMIT_FIELD_NAME = "submit";
var ContactForm = (function () {
    function ContactForm() {
    }
    ContactForm.prototype.init = function () {
        var _this = this;
        var formEl = this.getFormEl();
        if (!formEl) {
            return;
        }
        formEl.addEventListener('submit', function (e) { return _this.onSubmit(e); });
        this.getFields().forEach(function (f) {
            f.addEventListener('focus', function () { return _this.clearFieldError(f.getAttribute('name')); });
        });
    };
    ContactForm.prototype.refreshCaptcha = function () {
        var captchaEl = this.getFormEl().querySelector(CAPTCHA_SELECTOR);
        captchaEl.querySelector(CAPTCHA_REFRESH_SELECTOR).dispatchEvent(new MouseEvent('click'));
        this.clearField(CAPTCHA_FIELD_NAME);
    };
    ContactForm.prototype.onSubmit = function (e) {
        var _this = this;
        // Prevent normal sending of the form
        e.preventDefault();
        var data = this.collectFormData();
        var url = this.getFormUrl();
        // Clear field errors whenever we start sending the form
        this.clearErrors();
        this.setSendButtonState(SendButtonState.Sending);
        this.sendForm(url, data)
            .then(function (response) { return _this.handleResponse(response); });
    };
    ContactForm.prototype.getSendButtonEl = function () {
        return this.getFormEl().querySelector('button[name="submit"]');
    };
    /**
     * Updates the state of the send button
     *
     * The state button changes to a "Sending..." text when clicked
     * When the response is received, the button is temporarily set to
     * "Sent" for a few seconds and then reverted to its original state.
     */
    ContactForm.prototype.setSendButtonState = function (state) {
        var _this = this;
        // If it's not yet reset to original state, but it's pending, cancel it
        if (this.resetSendButtonStateId) {
            clearTimeout(this.resetSendButtonStateId);
            this.resetSendButtonStateId = void 0;
        }
        // Queue setting the state back to original after showing the "Sent" text for some time
        if (state === SendButtonState.Sent) {
            this.resetSendButtonStateId = setTimeout(function () { return _this.setSendButtonState(SendButtonState.Send); }, 6000);
        }
        var buttonEl = this.getSendButtonEl();
        buttonEl.disabled = state === SendButtonState.Sending;
        var labels = new Map()
            .set(SendButtonState.Send, buttonEl.getAttribute('data-send'))
            .set(SendButtonState.Sending, buttonEl.getAttribute('data-sending'))
            .set(SendButtonState.Sent, buttonEl.getAttribute('data-sent'));
        buttonEl.innerHTML = labels.get(state);
        if (state === SendButtonState.Sent) {
            buttonEl.classList.add(BUTTON_SENT_CLASS);
            $(".success-confirmation-message").removeClass('fadeOut').addClass('fadeIn');
        }
        else {
            buttonEl.classList.remove(BUTTON_SENT_CLASS);
            if (state === SendButtonState.Send && $(".success-confirmation-message").hasClass('fadeIn')) {
                $(".success-confirmation-message").removeClass('fadeIn').addClass('fadeOut');
            }
        }
    };
    ContactForm.prototype.handleResponse = function (response) {
        this.refreshCaptcha();
        if (response.status === 'error') {
            this.handleError(response.errors);
        }
        else {
            this.handleSuccess();
        }
    };
    ContactForm.prototype.handleError = function (errors) {
        for (var fieldName in errors) {
            if (errors.hasOwnProperty(fieldName)) {
                this.setFieldError(fieldName, errors[fieldName]);
            }
        }
        this.setSendButtonState(SendButtonState.Send);
    };
    ContactForm.prototype.setFieldError = function (fieldName, errorMessage) {
        var fieldEl = this.getFieldElement(fieldName);
        if (fieldName !== SUBMIT_FIELD_NAME) {
            fieldEl.classList.add(FIELD_ERROR_CLASS);
        }
        var errorEl = document.createElement('div');
        errorEl.classList.add(FIELD_ERROR_MESSAGE_CLASS);
        errorEl.innerHTML = errorMessage;
        var targetEl = this.getFormEl();
        var refChild;
        if (fieldName === CAPTCHA_FIELD_NAME) {
            refChild = this.getSendButtonEl().parentNode;
        }
        else {
            refChild = fieldEl.nextSibling;
        }
        targetEl.insertBefore(errorEl, refChild);
    };
    ContactForm.prototype.clearFieldError = function (fieldName) {
        var fieldEl = this.getFieldElement(fieldName);
        fieldEl.classList.remove(FIELD_ERROR_CLASS);
        var fieldErrorEl = this.getErrorFieldEl(fieldName);
        if (fieldErrorEl) {
            fieldErrorEl.remove();
        }
    };
    ContactForm.prototype.getErrorFieldEl = function (fieldName) {
        // We need to target the message element based on the field to which it is "attached"
        var messageAnchorSelector;
        if (fieldName === CAPTCHA_FIELD_NAME) {
            messageAnchorSelector = CAPTCHA_SELECTOR;
        }
        else {
            messageAnchorSelector = "[name=\"" + fieldName + "\"]";
        }
        return this.getFormEl().querySelector(messageAnchorSelector + " + ." + FIELD_ERROR_MESSAGE_CLASS);
    };
    ContactForm.prototype.clearErrors = function () {
        var _this = this;
        this.getFields().forEach(function (f) { return _this.clearFieldError(f.getAttribute('name')); });
        this.clearFieldError(SUBMIT_FIELD_NAME);
    };
    ContactForm.prototype.clearField = function (fieldName) {
        var field = this.getFields().find(function (f) { return f.getAttribute('name') === fieldName; });
        field.value = "";
    };
    ContactForm.prototype.clearFields = function () {
        this.getFields().forEach(function (f) { return f.value = ""; });
    };
    ContactForm.prototype.handleSuccess = function () {
        this.clearErrors();
        this.clearFields();
        this.setSendButtonState(SendButtonState.Sent);
    };
    ContactForm.prototype.sendForm = function (url, data) {
        return Promise.resolve($.ajax({
            url: url,
            data: data,
            method: "POST"
        })).then(function (r) { return JSON.parse(r); });
    };
    ContactForm.prototype.getFormEl = function () {
        return document.querySelector(FORM_SELECTOR);
    };
    ContactForm.prototype.getFieldElement = function (fieldName) {
        return this.getFormEl().querySelector("[name=\"" + fieldName + "\"]");
    };
    ContactForm.prototype.getFormUrl = function () {
        return this.getFormEl().getAttribute('action');
    };
    ContactForm.prototype.getFields = function () {
        return Array.from(this.getFormEl().querySelectorAll('input[type="text"], textarea'));
    };
    ContactForm.prototype.collectFormData = function () {
        var fields = this.getFields();
        var postData = {};
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var field = fields_1[_i];
            postData[field.getAttribute('name')] = field.value;
        }
        return postData;
    };
    return ContactForm;
}());
module.exports = new ContactForm;


/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** vcardWeb.bundle.js
 **/